import { motion } from "framer-motion";
import { useContext } from "react";
import { ThemeContext } from "../../contexts/ThemeProvider";
import { LanguageContext } from "../../contexts/LanguageProvider";
import { iconsMap } from "../icons";
import { icons } from "lucide-react";
export default function Components() {
  const { t } = useContext(LanguageContext);
  const cards = [
    {
      icon: iconsMap["leaves"],
      title: t("home-components-feature-1"),
      description: t("home-components-feature-1-description"),
    },
    {
      icon: iconsMap["attendance"],
      title: t("home-components-feature-2"),
      description: t("home-components-feature-2-description"),
    },
    {
      icon: iconsMap["documents"],
      title: t("home-components-feature-3"),
      description: t("home-components-feature-3-description"),
    },
    {
      icon: iconsMap["resources"],
      title: t("home-components-feature-4"),
      description: t("home-components-feature-4-description"),
    },
    {
      icon: "",
      title: t("home-components-feature-5"),
      description: t("home-components-feature-5-description"),
    },
    {
      icon: iconsMap["salary"],
      title: t("home-components-feature-6"),
      description: t("home-components-feature-6-description"),
    },
    {
      icon: iconsMap["dossary"],
      title: t("home-components-feature-7"),
      description: t("home-components-feature-7-description"),
    },
    {
      icon: "",
      title: t("home-components-feature-8"),
      description: t("home-components-feature-8-description"),
    },
  ];

  const { colorsObj } = useContext(ThemeContext);
  return (
    <section
      style={{
        backgroundColor: colorsObj.colorText,
        color: colorsObj.colorBackground,
      }}
      className={` py-16 px-6 lg:px-24 `}
    >
      <div className="text-center mb-12">
        <h2
          style={{ color: colorsObj.colorBackground }}
          className={`text-4xl font-bold mb-4`}
        >
          {t("home-components-title")}
        </h2>
        <p
          className={`text-lg text-[${colorsObj.colorBackground}]   max-w-3xl mx-auto`}
        >
          {t("home-components-subtitle")}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 text- lg:grid-cols-3 gap-8 ">
        {cards.map((card, index) => (
          <motion.div
            style={{
              boxShadow: `0px 4px 12px ${colorsObj.colorPrimary + "30"}`,
            }}
            key={index}
            className={`bg-[${colorsObj.colorText}] rounded-2xl p-6 shadow-md cursor-pointer`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0px 12px 24px rgba(0, 0, 0, 0.1)",
              transition: { duration: 0.5, delay: 0 },
            }}
          >
            <div className="text-4xl mb-4">
              {card.icon === "" ? "" : card.icon}
            </div>
            {card.icon === "" && (
              <img
                src={index === 4 ? "/echipamente.svg" : "/sarcini.svg"}
                alt="Echipamente"
                className="w-8  mb-4"
              />
            )}
            <h3
              className={`text-xl font-semibold mb-2 text-[${colorsObj.colorBackground}]`}
            >
              {card.title}
            </h3>
            <p className={`text-[${colorsObj.colorBackground}]`}>
              {card.description}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
